import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalLoaderService {
  isLoading = signal<boolean>(false);
  public errorMessage = signal<string>('');

  constructor() { }
}
